import React from 'react';

const About: React.FC = () => {
  return (
    <div>
      <div className="hero">
        <h1>About Us</h1>
        <p>Your Trusted Partner in Algorithmic Trading</p>
      </div>

      <div className="container">
        <div className="grid">
          <div className="card">
            <img
              src="/images/our_team.jpg"
              alt="Our Team"
              style={{ width: '100%', height: '300px', objectFit: 'cover', borderRadius: '8px', marginBottom: '1.5rem' }}
            />
            <h3>Our Story</h3>
            <p>
              Founded in 2023, we are a team of experienced traders and software developers
              dedicated to creating powerful algorithmic trading solutions. Our mission is to
              democratize access to advanced trading strategies through innovative Expert Advisors.
            </p>
            <p>
              With experience in both forex trading and software development,
              we understand the challenges traders face and work tirelessly to provide
              solutions that make a difference.
            </p>
          </div>
          <div className="card">
            <img
              src="/images/expertise.jpg"
              alt="Our Office"
              style={{ width: '100%', height: '300px', objectFit: 'cover', borderRadius: '8px', marginBottom: '1.5rem' }}
            />
            <h3>Our Expertise</h3>
            <p>Our team combines expertise in:</p>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {[
                'Algorithmic Trading Development',
                'MQL5 Programming',
                'Risk Management',
                'Market Analysis',
                'Technical Analysis'
              ].map((expertise, index) => (
                <li key={index} style={{ marginBottom: '0.5rem', paddingLeft: '1.5rem', position: 'relative' }}>
                  <span style={{ position: 'absolute', left: 0, color: '#1a237e' }}>•</span>
                  {expertise}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="text-center" style={{ marginTop: '4rem' }}>
          <h2>Our Values</h2>
        </div>
        <div className="grid">
          {[
            {
              title: 'Innovation',
              description: 'Constantly developing new strategies and improving our technology',
              icon: '/images/innovation.jpg'
            },
            {
              title: 'Reliability',
              description: 'Providing stable and consistent trading solutions',
              icon: '/images/reliability.jpg'
            },
            {
              title: 'Transparency',
              description: 'Being open and honest about our products and services',
              icon: '/images/transparency.jpg'
            },
            {
              title: 'Customer Success',
              description: 'Committed to helping our clients achieve their trading goals',
              icon: '/images/cust-success.jpg'
            }
          ].map((value, index) => (
            <div className="feature-card" key={index}>
              <img src={value.icon} alt={value.title} />
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center" style={{ marginTop: '4rem' }}>
          <h2>Our Team</h2>
        </div>
        <div className="grid">
          {[
            {
              name: 'Saifullah Khan',
              role: 'Lead Developer',
              image: 'https://source.unsplash.com/random/200x200?portrait'
            },
            {
              name: 'Sufyan Ijaz',
              role: 'Trading Strategist',
              image: 'https://source.unsplash.com/random/200x200?woman'
            },
            {
              name: 'Abdul Rehman Wasil',
              role: 'Risk Manager',
              image: 'https://source.unsplash.com/random/200x200?man'
            }
          ].map((member, index) => (
            <div className="card" key={index} style={{ textAlign: 'center' }}>
              <img
                src={member.image}
                alt={member.name}
                style={{
                  width: '150px',
                  height: '150px',
                  borderRadius: '50%',
                  marginBottom: '1rem',
                  objectFit: 'cover'
                }}
              />
              <h3>{member.name}</h3>
              <p style={{ color: '#666' }}>{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About; 